import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

// Components
import Success from './Success';

// Selectors
import { getExternalValetProvider } from 'store/reducers/dealerSettings/selectors';

// Selectors
import { getTransportationOption } from 'store/reducers/appointment/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  externalValet: getExternalValetProvider(state),
  transportationOption: getTransportationOption(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(Success);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/components/Success/SuccessContainer.js